import React, { useEffect, useState } from 'react'
import Section from '../../../../../../components/Section'
import MoneyInput from '../../../../../../components/form/MoneyInput'
import { dateToString } from '../../../../../../utils/string'
import { LongTermContractVolumes } from '../../../types'

import { ContractPurchaseInfoError } from '../types'

import { CurrencyList } from '../../../../Plans/Positions/Edit/types'

import CurrencyExchangeInput from '../../../../../../components/form/CurrencyExchangeInput'

import HoverTooltip from '../../../../../../components/HoverTooltip'

type Props = {
    title: string
    yearlyPayments: LongTermContractVolumes | null
    contractAction: boolean
    onYearlyPaymentsChange: (year: number, value: number) => void
    currency: number | null
    currencyExchangeRate?: number
    currencyList: CurrencyList[]
    errors?: ContractPurchaseInfoError
}

const _HEAD_CLS_NAME =
    'py-4 bg-neutral-700/50 font-normal text-xs text-[#6A6A6A] dark:text-[#8A8A8A]'
const _CELL_CLS_NAME = 'p-1 bg-[#18181b]/20'
const _INPUT_CLS_NAME = 'form-input-table-row w-full text-[11px]'

const ContractPaymentBreakdown: React.FC<Props> = (props) => {
    const isForeignCurrency =
        props.currency !== 643 && props.currencyExchangeRate

    return (
        <Section title={props.title}>
            <fieldset disabled={props.contractAction}>
                <div className="form-label">Планируемые платежи</div>
                {/* table */}
                <div className="flex flex-col w-full min-w-fit rounded">
                    {/* name */}
                    <div className="flex flex-row gap-1 h-10 bg-[#d2d5d8] dark:bg-[#2A282B] text-[#6A6A6A] dark:text-[#8A8A8A] text-[10px] p-1 rounded-t">
                        <div className="grid w-12 place-items-center text-center">
                            Год
                        </div>
                        <div className="grid w-24 flex-1 place-items-center text-center">
                            Сумма
                        </div>
                        {isForeignCurrency && (
                            <div className="grid w-24 flex-1 place-items-center text-center">
                                Сумма в рублевом эквиваленте
                            </div>
                        )}
                    </div>

                    {/* date */}
                    <div className="flex flex-col bg-[#e0e3e6] dark:bg-[#242225] rounded-b overflow-y-auto custom-scrollbar">
                        {props.yearlyPayments &&
                            Array.from(
                                props.yearlyPayments.details?.items ?? []
                            ).map((payment, index) => {
                                const year = payment.year
                                const amount = payment.summ
                                return (
                                    <div
                                        key={index}
                                        className="flex flex-row gap-1 p-1 text-[#181818] dark:text-[#FFFFFF] text-[11px]"
                                    >
                                        <div
                                            key={year}
                                            className="grid w-12 place-items-center text-center"
                                        >
                                            {year}
                                        </div>
                                        <div className="flex-1">
                                            <MoneyInput
                                                className={
                                                    _INPUT_CLS_NAME +
                                                    ' px-2 py-1 h-[28px] rounded-md'
                                                }
                                                value={amount}
                                                onChange={(newValue) =>
                                                    props.onYearlyPaymentsChange(
                                                        year,
                                                        newValue
                                                    )
                                                }
                                            />
                                        </div>

                                        {isForeignCurrency && (
                                            <div className="flex-1 ">
                                                <MoneyInput
                                                    className={
                                                        _INPUT_CLS_NAME +
                                                        ' px-2 py-1 h-[28px] rounded-md'
                                                    }
                                                    value={
                                                        amount *
                                                        (props.currencyExchangeRate as number)
                                                    }
                                                    disabled
                                                />
                                            </div>
                                        )}
                                    </div>
                                )
                            })}
                        <HoverTooltip
                            tooltipText={
                                props.title ==
                                'Информация об объемах оплаты долгосрочного договора'
                                    ? props.errors?.notice_44 || ''
                                    : props.errors?.notice_44 || ''
                            }
                        >
                            <div
                                className={`flex flex-row gap-1 p-1 text-[#181818] dark:text-[#FFFFFF] text-[11px] rounded-md ${
                                    props.title ==
                                    'Информация об объемах оплаты долгосрочного договора'
                                        ? props.errors?.notice_44
                                            ? 'border border-[#C15C5C]'
                                            : ''
                                        : props.errors?.notice_44
                                          ? 'border border-[#C15C5C]'
                                          : ''
                                }`}
                            >
                                <div className="grid w-12 place-items-center text-center">
                                    Всего
                                </div>
                                <div className="flex-1">
                                    <MoneyInput
                                        className={
                                            _INPUT_CLS_NAME +
                                            ' px-2 py-1 h-[28px] rounded-md'
                                        }
                                        value={props.yearlyPayments?.volume} //Если volume пустой, подставляем 0
                                        disabled
                                    />
                                </div>
                                {isForeignCurrency && (
                                    <div className="flex-1">
                                        <MoneyInput
                                            className={
                                                _INPUT_CLS_NAME +
                                                ' px-2 py-1 h-[28px] rounded-md'
                                            }
                                            value={
                                                (props.yearlyPayments?.volume ||
                                                    0) *
                                                (props.currencyExchangeRate as number)
                                            }
                                            disabled
                                        />
                                    </div>
                                )}
                            </div>
                        </HoverTooltip>
                    </div>
                </div>
            </fieldset>
        </Section>
    )
}

export default ContractPaymentBreakdown
